import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuditLog } from '../+models/audit-log.model';
import { AuditActionType } from '../+models/audit-action-type.enum';

@Component({
  selector: 'sd-portal-audit-detail',
  templateUrl: './audit-detail.component.html',
  styleUrls: ['./audit-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuditDetailComponent implements OnInit {
  @Input() audit: AuditLog;

  actionType = AuditActionType;

  ngOnInit() {}
}
